export default {
  days: [],
};
